// Shared behavior for the "Online Mağaza Temsilciliği" application funnel:
// smooth-scroll-to-form CTAs (with focus handoff for keyboard/AT users) and
// the sticky apply bar's show/hide-after-hero logic. Deliberately static
// otherwise — no scroll-triggered motion, nothing moves on its own.

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-temsilci-scroll-target]');
  if (!trigger) return;

  const target = document.getElementById(trigger.dataset.temsilciScrollTarget);
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });

  const focusable = target.querySelector('input, textarea, select, button');
  if (focusable) {
    window.setTimeout(() => focusable.focus({ preventScroll: true }), 500);
  }
});

class TemsilciStickyBar extends HTMLElement {
  connectedCallback() {
    const revealAfter = document.getElementById(this.dataset.revealAfter);
    const hideAt = document.getElementById(this.dataset.hideAt);

    if (revealAfter) {
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          this.pastHero = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          this.updateVisibility();
        },
        { threshold: 0 }
      );
      this.revealObserver.observe(revealAfter);
    }

    if (hideAt) {
      this.hideObserver = new IntersectionObserver(
        (entries) => {
          this.reachedForm = entries[0].isIntersecting;
          this.updateVisibility();
        },
        { threshold: 0 }
      );
      this.hideObserver.observe(hideAt);
    }
  }

  updateVisibility() {
    const shouldShow = this.pastHero && !this.reachedForm;
    this.classList.toggle('temsilci-sticky-bar--visible', Boolean(shouldShow));
  }

  disconnectedCallback() {
    this.revealObserver?.disconnect();
    this.hideObserver?.disconnect();
  }
}

customElements.define('temsilci-sticky-bar', TemsilciStickyBar);
